import { registerBlockType } from '@wordpress/blocks';
import { InnerBlocks } from '@wordpress/block-editor';
import metadata from './block.json';
import Edit from './Edit';
import './style.scss';

registerBlockType(metadata.name, {
  edit: Edit,
  // Dynamic block: render.php owns the frontend markup; only inner slides persist.
  save: () => <InnerBlocks.Content />,
  icon: {
    foreground: '#0061FE',
    src: (
      // A cube drawn as one face plus the two edges receding from it.
      // Inline fill:none required: `foreground` adds .has-colors whose
      // `fill: currentcolor` overrides the SVG fill attribute.
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: 'none' }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 3.5l7 3.75v9.5L12 20.5l-7-3.75v-9.5z" />
        <path d="M12 3.5v17M5 7.25l7 3.75 7-3.75" />
      </svg>
    ),
  },
});
